import React from "react";
import { connect } from "react-redux";
import _ from "lodash";
import * as resActions from "../../modules/resources";
import PaginationFilter from "Components/paginationFilter/PaginationFilter";
import withPagination from "Components/withPagination";
import Button from "Components/button/Button";
import PropTypes from "prop-types";
import FullPaginationControls from "Components/fullPaginationControls/FullPaginationControls";
import ConfirmModal from "Components/confirmModal/ConfirmModal";
import { alertSuccess } from "Utils/alerts";
import TranslatedString from "Components/TranslatedString";

import ManagerCard from "Components/managerCard/ManagerCard";

import { plus } from "Icons/index";
import t from "Utils/translation";
import cx from "classnames";
import s from "./listAdmins.scss";

const propTypes = {};

const ContextTypes = {
  router: PropTypes.object,
  getLoggedUser: PropTypes.func,
  getLoggedUserType: PropTypes.func,
  isMobileDevice: PropTypes.func,
  isMediaMobile: PropTypes.func,
  isMediaSM: PropTypes.func,
  isMediaMD: PropTypes.func,
  isMediaLG: PropTypes.func
};

class AdminsListScreen extends React.Component {
  constructor(props) {
    super(props);
    this.add = this.add.bind(this);
    this.deleteAdmin = this.deleteAdmin.bind(this);
    this.closeConfirmModal = this.closeConfirmModal.bind(this);
    this.openConfirmModal = this.openConfirmModal.bind(this);
    this.show = this.show.bind(this);

    this.state = {
      confirmModalOpened: false,
      selectedAdmin: {}
    };
  }

  componentDidMount() {
    this.props.getAdmins(this.props.location.search);
  }

  closeConfirmModal() {
    this.setState({ confirmModalOpened: false, selectedAdmin: {} });
  }

  openConfirmModal(dom) {
    this.setState({ confirmModalOpened: true, selectedAdmin: dom });
  }

  add() {
    this.props.history.push("admins/add");
  }

  show(code) {
    this.props.history.push({
      pathname: `/admins/${code}`,
      state: {
        prevPagination: this.props.location.search
      }
    });
  }

  deleteAdmin() {
    const code = this.state.selectedAdmin.code;
    this.props.deleteAdmin(code);
    this.props.optimisticallyDeleteResource(code);
    this.closeConfirmModal();
    alertSuccess(t("alert.admin.deleted"));
  }

  render() {
    const {
      areAdminsLoading,
      admins,
      paginationInfo,
      location,
      isRefreshing,
      refreshList
    } = this.props;

    const { isMobileDevice, isMediaMobile, isMediaSM, isMediaMD, isMediaLG } = this.context;

    return (
      <div className={s.listAdmins}>
        <div className={s.headerList}>
          <div className={cx("sectionTitle", s.titleList)}>{t("admins.list.header.title")}</div>

          {!isMediaMobile() && (
            <div className={cx("sectionDesc", s.descList)}>
              <TranslatedString>admins.list.header.dsc</TranslatedString>
            </div>
          )}

          <div className={s.actionsList}>
            <Button icon={plus} onClick={this.add} onlyIcon={isMediaMobile()}>
              button.addAdmin
            </Button>
          </div>
        </div>
        <div className={s.contentList}>
          <FullPaginationControls
            className={s.filters}
            paginationInfo={paginationInfo}
            location={location}
            refreshList={refreshList}
            showListFilter={false}
            showPaginationFilter={false}
            isLoading={areAdminsLoading || isRefreshing}
          />
          <div className={s.table}>
            {_.map(admins, adm => {
              return (
                <ManagerCard
                  {...adm}
                  key={adm.code}
                  showManager={this.show}
                  changeStatusDisabled
                  delete={() => this.openConfirmModal(adm)}
                />
              );
            })}
          </div>
        </div>
        <ConfirmModal
          title={t("confirmationModal.title.delete.admin")}
          text={
            <TranslatedString subs={{ nameAdmin: this.state.selectedAdmin.fullname }}>
              confirmationModal.text.delete.admin
            </TranslatedString>
          }
          textButton={`button.delete`}
          opened={this.state.confirmModalOpened}
          action={this.deleteAdmin}
          handleClose={this.closeConfirmModal}
        />
      </div>
    );
  }
}

//AdminsListScreen.propTypes = propTypes;
AdminsListScreen.contextTypes = ContextTypes;

const mapStateToProps = state => ({
  admins: resActions.getData("admins.data", state),
  paginationInfo: resActions.getData("admins.paginationInfo", state),
  areAdminsLoading: resActions.isResourceLoading("admins", state)
});

const mapDispatchToProps = dispatch => ({
  getAdmins: queryParams => dispatch(resActions.callApi("getAdmins", "admins", queryParams)),
  retrievePagination: queryParams =>
    dispatch(resActions.callApi("getAdmins", "admins", queryParams)),
  deleteAdmin: code => dispatch(resActions.callApi("deleteAdmin", "admins", code)),
  optimisticallyDeleteResource: code => {
    dispatch(
      resActions.optimisticallyDeleteResource({
        resourcesType: "admins",
        resourceCode: code
      })
    );
  }
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withPagination(AdminsListScreen));
